var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.list.length > 0
    ? _c(
        "div",
        { staticClass: "publicidades" },
        [
          _vm._l(_vm.list, function(item, index) {
            return _vm.type == 1
              ? _c(
                  "a",
                  {
                    attrs: {
                      title: item.title,
                      href: item.url,
                      target: item.target
                    }
                  },
                  [
                    _c("section", {
                      staticClass: "spacing-tb parallax",
                      style: {
                        backgroundImage: "url( " + item.file + " )"
                      }
                    })
                  ]
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _vm.type == 2 && _vm.list.length > 0
            ? _c("div", { staticClass: "fixed-footer" }, [
                _c("div", { staticClass: "container" }, [
                  _c(
                    "div",
                    { staticClass: "g g-1180" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "close f-right",
                          on: { click: _vm.closeFixed }
                        },
                        [
                          _vm._v("Fechar "),
                          _c("i", { staticClass: "fas fa-window-close" })
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.list, function(item, index) {
                        return _c(
                          "a",
                          {
                            attrs: {
                              title: item.title,
                              href: item.url,
                              target: item.target
                            }
                          },
                          [
                            _c("img", {
                              attrs: { src: item.file, alt: item.title }
                            })
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type == 3 && _vm.list.length > 0
            ? _c(
                "div",
                { staticClass: "popup", on: { click: _vm.closePopUp } },
                [
                  _c(
                    "div",
                    { staticClass: "img-container" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "close f-right",
                          on: { click: _vm.closePopUp }
                        },
                        [
                          _vm._v("Fechar "),
                          _c("i", { staticClass: "fas fa-window-close" })
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.list, function(item, index) {
                        return _c(
                          "a",
                          {
                            attrs: {
                              title: item.title,
                              href: item.url,
                              target: item.target
                            }
                          },
                          [
                            _c("img", {
                              attrs: { src: item.file, alt: item.title }
                            })
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.type == 4 && _vm.list.length > 0
            ? _c(
                "section",
                {
                  staticClass: "banner-box cycle-slideshow",
                  attrs: {
                    "data-cycle-center-horz": "true",
                    "data-cycle-center-vert": "true",
                    "data-cycle-timeout": "4000",
                    "data-cycle-slides": "a"
                  }
                },
                _vm._l(_vm.list, function(item, index) {
                  return _c(
                    "a",
                    {
                      attrs: {
                        title: item.title,
                        href: item.url,
                        target: item.target
                      }
                    },
                    [_c("img", { attrs: { src: item.file, alt: item.title } })]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.type == 5 && _vm.list.length > 0
            ? _c("section", { staticClass: "fixed-banner fixed-footer" }, [
                _c(
                  "span",
                  {
                    staticClass: "close-fixed-banner",
                    on: { click: _vm.closeFixed }
                  },
                  [_c("i", { staticClass: "fas fa-window-close" })]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "cycle-slideshow",
                    attrs: {
                      "data-cycle-timeout": "4000",
                      "data-cycle-slides": "a"
                    }
                  },
                  _vm._l(_vm.list, function(item, index) {
                    return _c(
                      "a",
                      {
                        attrs: {
                          title: item.title,
                          href: item.url,
                          target: item.target
                        }
                      },
                      [
                        _c("img", {
                          attrs: { src: item.file, alt: item.title }
                        })
                      ]
                    )
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.list, function(item, index) {
            return _vm.type == 0
              ? _c(
                  "a",
                  {
                    attrs: {
                      title: item.title,
                      href: item.url,
                      target: item.target
                    }
                  },
                  [_c("img", { attrs: { src: item.file, alt: item.title } })]
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _vm.showBadge
            ? _c("span", { staticClass: "badge" }, [_vm._v("Publicidades")])
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c6829d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c6829d2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue/front/Publicidades.vue
// module id = 41
// module chunks = 1 2